import { useState, useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Backdrop,
  Grid,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  CircularProgress,
  Alert
} from '@mui/material';
import {
  Select,
  MenuItem,
  Divider,
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
// project imports
import SubCard from 'src/components/cards/SubCard';
import { Delete } from '@material-ui/icons';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import Dropzone from 'react-dropzone-uploader';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import DescriptionIcon from '@mui/icons-material/Description';
// ==============================|| PROFILE 1 -DOCUMENTATION ||============================== //

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  confirmOverlay: {
    zIndex: 9999 + ' !important'
  }
}));


const Documentation = ({ ServiceShopId, ServiceShopFullName }) => {
  const theme = useTheme();
  const [documents, setDocuments] = useState([]);
  const [newDocumentType, setnewDocumentType] = useState('');
  const [newDocument, setNewDocument] = useState('');
  const [loading, setLoading] = useState(false);
  const SessionUser = getUser();
  const documentTypes = [
    { id: 1, type: 'Denetim Raporları' },
    { id: 2, type: 'Servis Geliştirme Faaliyetleri' },
    { id: 3, type: 'Servis Açılış Belgeleri' },
    { id: 4, type: 'Uyarı' },
    { id: 5, type: 'İhtar' },
    { id: 6, type: 'Savunma Talebi' },
    { id: 7, type: 'Savunma' },
  ];

  const documentsData = [
    { id: 1, type: 1, document: 'Yetkili Servis Denetim Formu' },
    { id: 2, type: 1, document: 'Yetkili Servis Denetim Takip Formu' },
    { id: 3, type: 1, document: 'Yetkili Servis Denetimi Soru Listesi' },
    { id: 4, type: 2, document: 'Yetkili Servis Gelisim Faaliyet Formu' },
    { id: 5, type: 2, document: 'Servis Gelistirme Soru Listesi' },
    { id: 6, type: 3, document: 'İmza Sirküleri' },
    { id: 7, type: 3, document: 'Sicil Tasdiknamesi' },
    { id: 8, type: 3, document: 'Şirket Ana Sözlesmesi' },
    { id: 9, type: 3, document: 'Yetkili Servis Sözleşmesi' },
    { id: 10, type: 3, document: 'Fesih Protokolü' },
    { id: 11, type: 3, document: 'Servis Sahibi Islak Imzalı Dilekçesi' },
    { id: 12, type: 3, document: 'İbra Protokolü' },
    { id: 13, type: 4, document: 'Uyari yazisi' },
    { id: 14, type: 5, document: 'Ihtar yazisi' },
    { id: 15, type: 6, document: 'Savunma talebi yazisi' },
    { id: 16, type: 7, document: 'Savunma yazisi' },
  ];


  const [uploadFilePopUp, setUploadFilePopUp] = useState(false);

  const handleDocument = (id) => {

    confirmAlert({
      message: "Belge silinecektir!... Devam etmek istediginizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleDocumentParam(id)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  };

  const handleDocumentParam = (id) => {
    setLoading(true);
    axios.get(`GetServiceDocuments/${id}/${3}`).then((response) => {
      setLoading(false);
      getEmployeeDocuments(2);
      setLoading(false);
    });
  };



  useEffect(() => {
    getEmployeeDocuments(2);
  }, []);

  const getEmployeeDocuments = (type) => {
    setLoading(true);
    axios.get(`GetServiceDocuments/${ServiceShopId}/${type}`).then((response) => {
      if (response.data.length > 0) {
        setDocuments(response.data);
      } else {
        setDocuments([]);
      }
      setLoading(false);
    });
  }

  const convertExcelToBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64String = event.target.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };


  const setNewWindowOpen = (id) => {
    setLoading(true);
    axios.get("/GetServiceDocuments/" + id + '/' + 1, {
      responseType: 'arrayBuffer'
    }).then(response => {
      setLoading(false);
      const res = response.data[0]
      if (!res) {
        return;
      } else {
        var FileData = `data:${res.FILE_TYPE};base64,${res.FILE_DATA}`
        if (res?.FILE_TYPE?.includes('image')) {
          var image = new Image();
          image.src = FileData;
          var w = window.open("");
          w.document.write(image.outerHTML);
          w.document.title = res.DOSYA_ADI;
          w.document.close();
        } else {
          var blobData = base64ToBlob(res.FILE_DATA, "application/pdf");
          openBlobInNewTab(blobData);
        }
      }
    });
  }


  function base64ToBlob(base64Data, contentType) {
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }
  function openBlobInNewTab(blobData) {
    var newTab = window.open();
    var objectUrl = URL.createObjectURL(blobData);
    newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
  }


  const convertWordToBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64String = event.target.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };
  ;

  const handleChangeStatus = () => { };
  const handleSubmitImage = async (files, allFiles) => {
    setLoading(true);
    for (let i = 0; i < files.length; i++) {
      const fileMaterial = files[i].file;
      const metaMaterial = files[i].meta;
      let base64ResultMaterial = '';
      if (metaMaterial.type.indexOf('image') !== -1) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const image = new Image();
        image.src = URL.createObjectURL(fileMaterial);
        await new Promise((resolve, reject) => {
          image.onload = () => {
            const maxWidth = 1920;
            const maxHeight = 1920;
            let width = image.width;
            let height = image.height;
            if (width > maxWidth || height > maxHeight) {
              if (width / height > maxWidth / maxHeight) {
                width = maxWidth;
                height = Math.round(maxWidth * (image.height / image.width));
              } else {
                height = maxHeight;
                width = Math.round(maxHeight * (image.width / image.height));
              }
            }
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(image, 0, 0, width, height);
            base64ResultMaterial = canvas.toDataURL(metaMaterial.type, 1).split(',')[1];
            resolve();
          };
          image.onerror = reject;
        });
      } else if (metaMaterial.type.indexOf('spreadsheet') !== -1) {
        // Assuming you have a function named "convertExcelToBase64" to handle Excel files
        base64ResultMaterial = await convertExcelToBase64(fileMaterial);
      } else if (metaMaterial.type.indexOf('word') !== -1) {
        // Assuming you have a function named "convertWordToBase64" to handle Word files
        base64ResultMaterial = await convertWordToBase64(fileMaterial);
      } else {
        base64ResultMaterial = await base64Reader(fileMaterial);
      }
      const data = {
        FileName: metaMaterial.name,
        FileType: metaMaterial.type,
        ServiceShopId: ServiceShopId,
        FileData: base64ResultMaterial,
        TypeId: newDocument,
        CreateUser: SessionUser.UserId,
      }
      uploadFiles(data)
      allFiles.forEach(f => f.remove())
      setLoading(false)
      setUploadFilePopUp(false)
      // setUyariTip("success");
    }
  };

  const classes = useStyles();

  function uploadFiles(filedata) {
    axios.post("/UploadFileService", filedata, {
      headers: { 'Content-Type': 'application/json' }
    }).then(response => {
      getEmployeeDocuments(2)
      setLoading(false);
    });
  }

  async function base64Reader(file) {
    const result_base64 = await new Promise(resolve => {
      const fileReader = new FileReader();
      fileReader.onload = e => resolve(fileReader.result);
      fileReader.readAsDataURL(file);
    });
    return result_base64.split(',')[1] || '';
  }



  return (
    <div>
      {
        loading ?
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SubCard title={ServiceShopFullName} style={{ minHeight: 100 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6}>
                <SubCard title="Dokümanlar" style={{ minHeight: 400 }}>
                  {documents.map((document) => (
                    <div key={document.id}>
                      <Grid container alignItems="center">
                        <Grid item xs={12} sm={6} md={6}>
                          <Typography>{document.DOSYA_ADI}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={3} md={3}>
                          <Typography variant="body2" color="textSecondary">
                            {document.ACIKLAMA}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={1} md={1}>
                          <IconButton onClick={() => setNewWindowOpen(document.id)}>
                            <DescriptionIcon style={{ color: '#FF9800' }} />
                          </IconButton>
                        </Grid>
                        {SessionUser.ManagementRoleId == 2 || SessionUser.ManagementRoleId == 1 || (document.id == 16 && SessionUser.ManagementRoleId == 4) ? 
                        <Grid item xs={12} sm={1} md={1}>
                          <IconButton onClick={() => handleDocument(document.id)}>
                            <Delete style={{ color: 'red' }} />
                          </IconButton>
                        </Grid>
                        : null }
                      </Grid>
                      <Divider />
                    </div>
                  ))}
                </SubCard>
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <SubCard title="Yeni Doküman Ekle" style={{ minHeight: 400 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-age-native-simple">Doküman Tipi</InputLabel>
                        <Select
                          label="Tip"
                          value={newDocumentType}
                          onChange={(e) => setnewDocumentType(e.target.value)}
                          fullWidth
                          size="small"
                          inputProps={{
                            name: 'age',
                            id: 'outlined-age-native-simple',
                          }}
                        >
                          {SessionUser.ManagementRoleId == 2 || SessionUser.ManagementRoleId == 1  ?  documentTypes.map((type) => (  
                            <MenuItem key={type.id} value={type.id}>
                              {type.type}
                            </MenuItem>
                          )): <MenuItem key={documentTypes[6].id} value={documentTypes[6].id}>
                              {documentTypes[6].type}
                            </MenuItem> }
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-age-native-simple">Doküman Adı</InputLabel>
                        <Select
                          label="Doküman Adı"
                          value={newDocument}
                          onChange={(e) => setNewDocument(e.target.value)}
                          fullWidth
                          inputProps={{
                            name: 'age',
                            id: 'outlined-age-native-simple',
                          }}
                        >
                          {documentsData
                            .filter((document) => document.type === newDocumentType)
                            .map((document) => (
                              <MenuItem key={document.id} value={document.id}>
                                {document.document}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} style={{ textAlign: "right" }}>
                      <Button
                        variant="contained"
                        color="secondary"
                        style={{ textTransform: 'none' }}
                        endIcon={<SaveAltIcon />}
                        onClick={() => setUploadFilePopUp(true)}
                      >
                        Ekle
                      </Button>
                    </Grid>
                  </Grid>
                </SubCard>
              </Grid>
            </Grid>
          </SubCard>
        </Grid>

        <Dialog
          open={uploadFilePopUp}
          onClose={() => setUploadFilePopUp(false)}
          aria-describedby="alert-dialog-slide-description"
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ width: '100%' }}>Dosya Yükle</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} style={{ paddingTop: 20 }}>
              <Grid item xs={12} md={12}>
                <Dropzone
                  onChangeStatus={handleChangeStatus}
                  accept="application/pdf"
                  onSubmit={handleSubmitImage}
                  styles={{
                    dropzone: { minHeight: 200, maxHeight: 250 }
                  }}
                  submitButtonContent="Yükle"
                  minSize={0}
                  maxSize={8072000}
                  inputWithFilesContent={(files) => `${3 - files.length} ekle`}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <IconButton
              color="primary"
              onClick={() => setUploadFilePopUp(false)}
              aria-label="close"
              component="span"
              variant="contained"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </Dialog>
      </Grid>

    </div>
  );
};

export default Documentation;
